import React from "react";
import { Edit, Delete } from "@mui/icons-material";
import "../css/ProsetSimpleGrid.css";
// import PremiumBackground from "./PremiumBackground";

const ProsetSimpleGrid = ({ columns, rows, onRowClick, onEdit, onDelete }) => {
  return (
    <div className="proset-grid">

{/*       <PremiumBackground /> */}

      {/* HEADER */}
      <div className="proset-grid-header">
        {columns.map((col) => (
          <div
            key={col.field}
            className="proset-grid-header-cell"
            style={{ flex: col.flex || 1 }}
          >
            {(col.headerName || "").toLocaleUpperCase("tr-TR")}
          </div>
        ))}
      </div>

      {/* BODY */}
      <div className="proset-grid-body">
        {rows.map((row) => (
          <div
            key={row.id}
            className="proset-grid-row"
            onClick={() => onRowClick?.(row)}
          >
            {columns.map((col) => (
              <div
                key={col.field}
                className={`proset-grid-cell ${col.field === "actions" ? "proset-grid-cell-actions" : ""}`}
                style={{ flex: col.flex || 1 }}
              >
                {/* ACTIONS HÜCRESİ */}
                {col.type === "actions" ? (
                  <div className="actions-wrapper" onClick={(e) => e.stopPropagation()}>
                    <Edit
                      className="action-icon edit"
                      onClick={() => onEdit(row)}
                    />

                    <Delete
                      className="action-icon delete"
                      onClick={() => onDelete(row)}
                    />
                  </div>
                ) : (
                  col.render ? col.render(row) : row[col.field]
                )}
              </div>
            ))}
          </div>
        ))}
      </div>

    </div>
  );
};

export default ProsetSimpleGrid;
